'use client';

import { useCallback, useEffect } from 'react';

import { useMultiModalWinner } from '@/hooks/useMultiModalWinner';
import { requestF5DB, requestPremiumDateDB } from '@/services/modalWinners';
import { EnumModalWinner } from '@/utils';

export const useModalChecks = (userInitialData: { pase_id?: string }) => {
  const { openModal, ModalWinner } = useMultiModalWinner();

  const checkModalPremiumDateDB = useCallback(async () => {
    if (!userInitialData?.pase_id) return;

    const response = await requestPremiumDateDB(userInitialData?.pase_id);

    if (
      response.estado &&
      !response.tieneDB &&
      response.razonesPedirDB &&
      response.razonesPedirDB.length > 0
    ) {
      const idRazon = response.razonesPedirDB[0].idRazon;

      const modalInfo = Object.values(EnumModalWinner).find(
        (item) => item.id === idRazon
      );

      if (modalInfo) {
        openModal({
          id: EnumModalWinner.FECHA_PREMIUM.id,
          title: modalInfo.titulo,
        });
      }
    }
  }, [openModal, userInitialData?.pase_id]);

  const checkModalF5DB = useCallback(async () => {
    if (!userInitialData?.pase_id) return;

    const response = await requestF5DB(userInitialData?.pase_id);

    if (
      response.estado &&
      !response.tieneDB &&
      response.razonesPedirDB &&
      response.razonesPedirDB.length > 0
    ) {
      const idRazon = response.razonesPedirDB[0].idRazon;

      const modalInfo = Object.values(EnumModalWinner).find(
        (item) => item.id === idRazon
      );

      if (modalInfo) {
        openModal({
          id:
            modalInfo.id === EnumModalWinner.FUTBOL5.id
              ? EnumModalWinner.FUTBOL5.id
              : EnumModalWinner.FUTBOL5_GRAL.id,
          title: modalInfo.titulo,
        });
      }
    }
  }, [openModal, userInitialData?.pase_id]);

  useEffect(() => {
    checkModalF5DB();
  }, [checkModalF5DB]);

  useEffect(() => {
    checkModalPremiumDateDB();
  }, [checkModalPremiumDateDB]);

  const PremiumWinnerModal = () => (
    <ModalWinner modalId={EnumModalWinner.FECHA_PREMIUM.id} />
  );
  const ModalDateF5 = () => (
    <ModalWinner modalId={EnumModalWinner.FUTBOL5.id} />
  );
  const ModalGralF5 = () => (
    <ModalWinner modalId={EnumModalWinner.FUTBOL5_GRAL.id} />
  );
  return {
    PremiumWinnerModal,
    ModalDateF5,
    ModalGralF5,
  };
};
